module.exports = __webpack_public_path__ + "img/cloud2_1.a50e2580.png";